module.exports = __webpack_public_path__ + "static/pay-later-3-27-4777830c1527510583217032c046fd36.svg";